export const notificationChannelModel = (data = {}) => ({
    uuid: data.uuid || '',
    code: data.code || '',
    name: data.name || '',
    isActive: data.is_active === true || Number(data.is_active) === 1,
});
